import moment from 'moment';

export const flattenForCSV = (data) => {
    if (data == null || data.mutualFunds === null) {
        return [];
    }
    return data.mutualFunds.map(
        ({
            ticker,
            name,
            price,
            twelveMonthLowPrice,
            twelveMonthHighPrice
        }) => ({
            'Fund Name': name,
            Ticker: ticker,
            'As of Date': moment(price.asOfDate).format('l'),
            Price: price.price,
            'Price Change $': price.priceChange,
            'Price Change %': price.pricePercentChange,
            '12 Month Low': twelveMonthLowPrice && twelveMonthLowPrice.price,
            '12 Month High': twelveMonthHighPrice && twelveMonthHighPrice.price
        })
    );
};
